<template>
  <div class="container-cidades">
    
    <div class="row">
    <div class="col-sm-12">
      <h1>Criar proposta</h1><br>
    </div>

      
          <div class="form-group col-sm-4">
          <label>Nome:</label>
          <input type="text" name="nome" class="form-control" value="" v-model="nome">
        </div>

        <div class="form-group col-sm-4">
          <label>Referência:</label>
          <input type="text" name="login" class="form-control" value="" v-model="referencia">
        </div>

       

          <button @click="add()" type="button" class="btn btn-warning col-sm-2" style="max-height:40px;margin-top:30px;">CRIAR</button>

        <div class="col-sm-2" v-if="loading" >
          <div class="spinner-border" role="status" style="max-height:40px;margin-top:35px;">
            <span class="sr-only">Loading...</span>
          </div>
        </div>

    </div><!-- row -->


    <div class="row">

 

    </div><!-- row table -->



  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'CriarProposta',
  components: {},
 
  data(){
      return {
          usuarios:[],
          nome:'',
          referencia:'',
          loading: false
      }
  },
 

methods:{
    add(){
          this.loading = true;
        
          axios
          .post('https://www2.royaljardim.com.br/sistema/propostas/criar',{nome:this.nome,referencia:this.referencia,permissao:this.getUsuarioID(),corretor:this.getUsuario()})
          .then( (response) => {this.loading = false;console.log(response);this.$router.push("/propostas");})
          .catch(response => console.log(response))
          
      },
    getUsuario(){
       return sessionStorage.getItem('imobiliariaNome');
     },
     getUsuarioID(){
       return sessionStorage.getItem('imobiliariaID');
     },
     getPermissao(){
       return sessionStorage.getItem('imobiliaria');
     }
  

},
  
  mounted () {
  
  }



}
</script>